import { render, staticRenderFns } from "./DashboardWrapper.vue?vue&type=template&id=a4873a70&scoped=true&"
import script from "./DashboardWrapper.vue?vue&type=script&lang=js&"
export * from "./DashboardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWrapper.vue?vue&type=style&index=0&id=a4873a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4873a70",
  null
  
)

export default component.exports